import { Box, Typography} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledElementBox = styled(Box)(({ theme }) => ({
    "&:hover": {
        cursor: "pointer",
    },
}));

const UserResultElement = ({ user, handleClick}) => {

    return (
        <StyledElementBox
            onClick={() => {
                handleClick(user);
            }}
            sx={{
                width: "100%",
                // p: 1,
                borderRadius: 1,
            }}
            // p={2}
        >
            <Typography variant="subtitle2">{user.user_id} {user.login} {user.full_name}</Typography>
        </StyledElementBox>
    );
};

export default UserResultElement;